import { IntegrationInitializationModal } from '../IntegrationInitializationModal'
import { IntegrationNotice } from '../IntegrationNotice'
import { useModals } from 'almanac-ui/Modal'
import Styles from '../IntegrationInitializationModal.module.scss'
import { Facebook } from 'almanac-ui/icons'
import { IntegrationInitializationDrawer } from '../IntegrationInitializationDrawer'
import { InitializationProps } from '../types'
import { useInitiateOauth } from 'hooks/useInitiateOauth'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'

export const FacebookNotice = () => (
  <IntegrationNotice
    connectionGuideLink="https://help.blaze.ai/en/articles/9556888-connect-blaze-to-facebook-business"
    message={
      <div className={Styles.message}>
        To setup Meta to Enable Facebook Business Scheduling, make sure:
        <ul className={Styles.list}>
          <li>You are the admin of a Facebook Business Page.</li>
          <li>Your Facebook Page is part of a Business Portfolio.</li>
          <li>Your personal Facebook account has admin rights to the Business Portfolio that the Page is a part of.</li>
        </ul>
        <div className={Styles.note}>If you are not sure if you have the right setup, review our guide:</div>
      </div>
    }
  />
)

const FacebookInitialization = ({ userIsAttemptingToPost = false, useDrawer = false }: InitializationProps) => {
  const { closeModal } = useModals()
  const { initiateOauth } = useInitiateOauth()

  const title = userIsAttemptingToPost
    ? 'Set up your Facebook Business integration'
    : 'Connect Facebook Business Account'

  const sharedProps = {
    notice: <FacebookNotice />,
    providerName: 'Facebook (Meta)',
    onClose: closeModal,
    icon: <Facebook size={32} />,
    title,
    onConfirm: () => initiateOauth(ExternalIntegrationEnum.Facebook),
    primaryButtonText: 'Go to Facebook Business',
  }

  return useDrawer ? (
    <IntegrationInitializationDrawer {...sharedProps} />
  ) : (
    <IntegrationInitializationModal {...sharedProps} />
  )
}

export default FacebookInitialization
